import './Contact.css';
import icon_email from './src/icon_email.png';
import icon_address from './src/icon_address.png';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import ContactIcon from './src/ContactIcon.png';
import {useTheme} from "../../ThemeProvider";

export default function Contact(){
    const { bgColor } = useTheme(); // Use the bgColor from the context

    return (
        <div style={{backgroundColoe:bgColor }}>

            <Breadcrumb style={{zIndex:"9",color:"white"}}>
                <Breadcrumb.Item href="/" style={{zIndex:"9"}}>Home</Breadcrumb.Item>
                <Breadcrumb.Item active style={{zIndex:"9",color:"white"}}>連絡先 Contact</Breadcrumb.Item>
            </Breadcrumb>

            <h1 className='page-type-name'>CONTACT</h1>

<div className='about-me-title-area-container'>
    <img className='about-me-img' src={ ContactIcon } alt="So Shimizu" style={{backgroundColor:"white"}}/>
    <div className='about-me-title-area'>
        <h1 className='page-subtitle'>連絡先</h1>
        <h1 className='page-title'>Contact</h1>
        <br/>
        <p>
        私の連絡先情報です。<br/>
                        学術論文や学会要旨の別刷の請求や昆虫の同定依頼、共同研究などのご相談にお使いください。<br/>
                        その他、私に関する情報はページ下部、フッターからご覧ください。
        </p>
    </div>
</div>

            <div className='main-area'>
                <div className='contact-icon-area'>
                    <img src={ icon_email } alt="email icon" className='contact-icon'/>
                    <div style={{"font-size":"28px","margin-bottom":"4px"}}><b>E-mail</b></div>
                    <div style={{"font-size":"26px"}}>
                        parasitoidwasp.sou # gmail $ com<br/>
                        "#" to "@"<br/>
                        "$" to "."
                    </div>
                </div>

                <div className='contact-icon-area'>
                    <img src={ icon_address } alt="email icon" className='contact-icon'/>
                    <div style={{"font-size":"28px","margin-bottom":"4px"}}><b>Affiriation address</b></div>
                    <div className='page-title-abstract-paragraph' style={{"padding":"8px"}}>
                        同定依頼標本等は以下の住所宛てにお願いいたします。<br/>
                        ※同定依頼の場合は必ず事前にメールにてご相談下さい。
                    </div>
                </div>
                <div style={{"height":"700px"}}></div>
            </div>
        </div>
    );
};